'use strict';

angular.module('formonlineApp').service('LocaliteService', ['$http',
    function ($http) {

        this.getAll = function () {
            return $http({
                method: 'get',
                url: 'api/localite'
            });
        };

        this.getByCanton = function (canton) {
            return $http({
                method: 'get',
                url: 'api/localite/canton/' + canton,
            });
        };

    }]);
